(function () {
  var MS_PER_DAY = 24 * 60 * 60 * 1000;

  function normalizeDays(value, fallback, max) {
    var days = Number(value);

    if (!Number.isFinite(days) || days < 1) return fallback;

    days = Math.round(days);
    return max ? Math.min(days, max) : days;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + normalizeDays(days, 30, 400) * MS_PER_DAY).toUTCString();
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var encoded = encodeURIComponent(name) + '=';
    return document.cookie.split(';').map(function (part) {
      return part.trim();
    }).find(function (part) {
      return part.indexOf(encoded) === 0;
    });
  }

  function ageGateReady() {
    var html = document.documentElement;
    var ageGate = document.querySelector('age-verification');

    if (html.classList.contains('age-verification-lock')) return false;
    if (ageGate && !html.classList.contains('age-verification-accepted')) return false;

    return true;
  }

  function initPopup(popup) {
    if (!popup || popup.dataset.newsletterPopupReady === 'true') return;

    var overlay = popup.querySelector('[data-newsletter-popup-overlay]');
    var dialog = popup.querySelector('[data-newsletter-popup-dialog]');
    var closeButtons = popup.querySelectorAll('[data-newsletter-popup-close]');
    var dismissButtons = popup.querySelectorAll('[data-newsletter-popup-dismiss]');
    var launcher = popup.querySelector('[data-newsletter-popup-launcher]');
    var form = popup.querySelector('[data-newsletter-popup-form]') || popup.querySelector('.newsletter-popup__form');
    var submit = popup.querySelector('[data-newsletter-submit]');
    var delay = Math.max(0, Number(popup.dataset.delaySeconds || 0)) * 1000;
    var storageKey = popup.dataset.storageKey || 'drshampoo.newsletterPopup.closed';
    var dismissCookie = popup.dataset.dismissCookie || 'drshampoo_newsletter_popup_dismissed';
    var subscribedCookie = popup.dataset.subscribedCookie || dismissCookie + '_subscribed';
    var dismissDays = normalizeDays(popup.dataset.dismissDays, 30, 400);
    var subscribedDays = normalizeDays(popup.dataset.subscribedDays, dismissDays, 400);
    var waitForAgeGate = popup.dataset.waitForAgeGate === 'true';
    var launcherEnabled = popup.dataset.launcherEnabled === 'true';
    var customerSubscribed = popup.dataset.customerSubscribed === 'true';
    var formSubscribed = Boolean(popup.querySelector('[data-newsletter-popup-success]'));
    var timer = null;

    function dismissed() {
      return Boolean(getCookie(dismissCookie) || getCookie(subscribedCookie));
    }

    function showLauncher() {
      if (!launcher || !launcherEnabled || dismissed()) return;
      launcher.hidden = false;
    }

    function hideLauncher() {
      if (launcher) launcher.hidden = true;
    }

    function openPopup(manual) {
      if (dismissed()) return;
      if (waitForAgeGate && !ageGateReady()) return;

      if (overlay) overlay.hidden = false;
      hideLauncher();

      window.setTimeout(function () {
        dialog?.focus();
      }, 0);

      if (manual) {
        try {
          window.sessionStorage.removeItem(storageKey);
        } catch (error) {
          /* sessionStorage can be unavailable in strict privacy modes. */
        }
      }
    }

    function closePopup(showBubble) {
      if (overlay) overlay.hidden = true;

      try {
        window.sessionStorage.setItem(storageKey, 'true');
      } catch (error) {
        /* sessionStorage can be unavailable in strict privacy modes. */
      }

      if (showBubble) showLauncher();
    }

    function dismissPopup() {
      setCookie(dismissCookie, 'true', dismissDays);
      if (overlay) overlay.hidden = true;
      hideLauncher();
    }

    function markSubscribed() {
      setCookie(subscribedCookie, 'true', subscribedDays);
      if (overlay) overlay.hidden = true;
      hideLauncher();
    }

    function scheduleOpen() {
      if (dismissed()) {
        if (overlay) overlay.hidden = true;
        hideLauncher();
        return;
      }

      if (waitForAgeGate && !ageGateReady()) {
        window.setTimeout(scheduleOpen, 500);
        return;
      }

      try {
        if (window.sessionStorage.getItem(storageKey) === 'true') {
          showLauncher();
          return;
        }
      } catch (error) {
        /* sessionStorage can be unavailable in strict privacy modes. */
      }

      timer = window.setTimeout(function () {
        openPopup(false);
      }, delay);
    }

    function setFieldError(input, message) {
      var field = input.closest('[data-newsletter-popup-field]');
      var error = field?.querySelector('[data-newsletter-popup-error]');

      if (!field || !error) return;

      field.classList.add('newsletter-popup__field--error');
      input.setAttribute('aria-invalid', 'true');
      error.textContent = message;
      error.hidden = false;
    }

    function clearFieldError(input) {
      var field = input.closest('[data-newsletter-popup-field]');
      var error = field?.querySelector('[data-newsletter-popup-error]');

      if (!field || !error) return;

      field.classList.remove('newsletter-popup__field--error');
      input.removeAttribute('aria-invalid');
      error.textContent = '';
      error.hidden = true;
    }

    function validateInput(input) {
      var value = input.value.trim();
      var requiredMessage = input.dataset.requiredMessage || 'Campo obrigatorio';
      var emailMessage = input.dataset.emailMessage || input.validationMessage;

      if (input.required && value === '') {
        setFieldError(input, requiredMessage);
        return false;
      }

      if (value !== '' && input.type === 'email' && !input.validity.valid) {
        setFieldError(input, emailMessage);
        return false;
      }

      clearFieldError(input);
      return true;
    }

    function validateForm() {
      if (!form) return true;

      var inputs = Array.from(form.querySelectorAll('[data-newsletter-popup-input]'));
      var invalidInput = inputs.find(function (input) {
        return !validateInput(input);
      });

      return !invalidInput ? true : invalidInput;
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (timer) window.clearTimeout(timer);
        closePopup(true);
      });
    });

    dismissButtons.forEach(function (button) {
      button.addEventListener('click', dismissPopup);
    });

    launcher?.addEventListener('click', function () {
      openPopup(true);
    });

    overlay?.addEventListener('click', function (event) {
      if (event.target === overlay && popup.dataset.closeOnOverlay === 'true') closePopup(true);
    });

    popup.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePopup(true);
    });

    form?.querySelectorAll('[data-newsletter-popup-input]').forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') === 'true') validateInput(input);
      });
      input.addEventListener('blur', function () {
        if (input.required && input.value.trim() !== '') validateInput(input);
      });
    });

    form?.addEventListener('submit', function (event) {
      if (submit && submit.disabled) {
        event.preventDefault();
        return;
      }

      var validationResult = validateForm();
      if (validationResult !== true) {
        event.preventDefault();
        validationResult.focus();
        return;
      }

      setCookie(subscribedCookie, 'true', subscribedDays);
    });

    popup.dataset.newsletterPopupReady = 'true';
    if (customerSubscribed || formSubscribed) {
      markSubscribed();
      return;
    }

    scheduleOpen();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-newsletter-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
